import React, { useEffect } from "react";
import { Modal, Form, Input, Switch, Button } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateFormPlanConfig } from "../../Services/form_question";

const PlanSwitchModal = ({ isModalVisible, handleCancel, data = [] }) => {
  const [form] = Form.useForm();
  const queryClient = useQueryClient();

  // Initialize form values from config_data
  useEffect(() => {
    if (data && data.length > 0) {
      const initialValues = {};
      data.forEach((item) => {
        const isBool = item.key.startsWith("is_");
        initialValues[item.key] = isBool
          ? item.value === "1" || item.value === "true"
          : Number(item.value);
      });
      form.setFieldsValue(initialValues);
    }
  }, [data, form]);

  const mutation = useMutation({
    mutationFn: updateFormPlanConfig,
    onSuccess: () => {
      queryClient.invalidateQueries(["form_question_master"]);
      handleCancel(); // close modal after success
    },
    onError: () => {
    },
  });

  const handleUpdate = () => {
    form
      .validateFields()
      .then((values) => {
        const payload = Object.entries(values).map(([key, value]) => {
          const configItem = data.find((d) => d.key === key);
          return {
            id: configItem?.id,
            key,
            value: typeof value === "boolean" ? (value ? "1" : "0") : String(value),
          };
        });
        mutation.mutate(payload);
      })
      .catch((err) => {
        console.error("Validation failed", err);
      });
  };

  return (
    <Modal
      title="Form Plan Configuration"
      open={isModalVisible}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="is_form_submission_plan"
          valuePropName="checked"
          label="Enable Form Submission Plan"
        >
          <Switch />
        </Form.Item>

        <Form.Item
          label="Increase the credit limit usage count"
          name="form_plan_capped_usage"
          rules={[
            { required: true, message: "Enter max usage count" },
            {
              validator: (_, value) => {
                if (value === undefined || value === null || value === "") {
                  return Promise.resolve(); // Let required rule handle it
                }

                return value >= 0
                  ? Promise.resolve()
                  : Promise.reject(new Error("Value cannot be negative"));
              }

            },
          ]}
        >
          <Input type="number" placeholder="Capped Usage Count" min={0} max={1000} />
        </Form.Item>

        <Form.Item>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
            <Button onClick={handleCancel}>Cancel</Button>
            <Button
              type="primary"
              onClick={handleUpdate}
              loading={mutation.isLoading}
            >
              Update
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PlanSwitchModal;
